export default __webpack_public_path__ + "static/media/blue-loader.def91951.svg";